var nurseslounge_myDashboard_myArticles = {
    section:'articles',
    init:function($params){
        var $homeArticles = $("#nurseslounge-home-articles");
        var $tab;
        if($params.notification_type == 'myPublishedArticle'){
            $tab = 'published-articles';
            libs.memorySave('nurseslounge_myDashboard_myArticles_notificationTypeKey', $params.notification_type_key);
        }
        var $section = nurseslounge_myDashboard_myArticles.section;
        nurseslounge_myDashboard_myArticles.goto($section, $tab, false);
        nurseslounge_myDashboard_myArticles.section = $section != 'articles' ? 'articles' : $section;
        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true);
        $("html, body").animate({scrollTop:$homeArticles.offset().top});
    },
    tab_open:'published-articles',
    goto:function($section, $tab, $autoScroll, cback){
        nurseslounge_myDashboard_myArticles.editor_is_not_saved($section, $tab, function(){
            $tab = $tab == undefined ? nurseslounge_myDashboard_myArticles.tab_open : $tab;
            $autoScroll = $autoScroll == undefined ? true : $autoScroll;
            var $homeArticles = $("#nurseslounge-home-articles");
            if($autoScroll){
                $("html, body").animate({scrollTop:$homeArticles.offset().top});
            }
            var $articlesMenu = $homeArticles.find('.articles-menu');
            var $articlesListMenu = $articlesMenu.find('.articles-list-menu');
            var $articlesEditorMenu = $articlesMenu.find('.articles-editor-menu');
            var $articlesList = $homeArticles.find('.articles-list');
            var $editorWrapper = $homeArticles.find('.editor-wrapper');
            if($section == 'articles' || $section == 'editor') {
                $articlesList.hide();
                $articlesListMenu.hide();
                $editorWrapper.hide();
                $articlesEditorMenu.hide();
            }
            if($section == 'articles'){
                $articlesListMenu.fadeIn();
                $articlesList.fadeIn(300, function () {
                    nurseslounge_myDashboard_myArticles.article_tabs_events($tab, function(){
                        nurseslounge_myDashboard_myArticles.article_list_pagination($tab);
                    });
                });
            }
            if($section == 'editor'){
                $articlesEditorMenu.fadeIn();
                $editorWrapper.fadeIn(300, function(){
                    nurseslounge_myDashboard_myArticles.editor();
                });
            }
            /*
            if($section == 'album'){
                var nlWallAlbum = $(window).nurseslounge_myDashboard_wall_get({user_id:libs.memoryGet('user_id')}, 'nlWallAlbum');
                nlWallAlbum.open({
                    on_close_modal:function(){
                        nurseslounge_myDashboard_myArticles.article_list_pagination('recommended-articles');
                        nurseslounge_myDashboard_myArticles.article_list_pagination('like-articles');
                        nurseslounge_myDashboard_myArticles.article_list_pagination('draft-articles');
                        nurseslounge_myDashboard_myArticles.article_list_pagination('published-articles');
                        nurseslounge_myDashboard_myArticles.article_list_pagination('recently-viewed-articles');
                    },
                    on_end_callback:false,
                    on_start_callback:false,
                    album_allow_tabs : {
                        'profile_webcam_image':false,
                        'profile_image':false,
                        'profile_document':false,
                        'profile_video':false,
                        'profile_article':true
                    },
                    album_step:11,
                    album_allow_add:false,
                    album_allow_select:false
                });
            }
             */
            $articlesMenu.find('a').unbind().click(function(){
                var $that = $(this);
                var $goto = $that.data('goto');
                nurseslounge_myDashboard_myArticles.goto($goto);
            });
        });
        if(cback != undefined){
            cback();
        }
    },
    //Articles
    article_tabs_events:function($tab, cback){
        var $allowTabs = [
            'recommended-articles',
            'like-articles',
            'draft-articles',
            'published-articles',
            'recently-viewed-articles',
            'trash-articles'
        ];
        var $articlesList = $("#nurseslounge-home-articles .articles-list");
        var $homeArticles = $("#nurseslounge-home-articles");
        //Disable All
        $articlesList.find('.nav-pills .nav-link').addClass('disabled').removeClass('active');
        $articlesList.find('.tab-pane .article-content').html('');
        //Events
        $articlesList.find('.nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
            var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
            if($.inArray($selectedTab, $allowTabs) > -1){
                nurseslounge_myDashboard_myArticles.article_list_pagination($selectedTab);
                $("html, body").animate({scrollTop:$homeArticles.offset().top});
            }
        });
        //Enable selected
        $.each($allowTabs, function ($i, $v) {
            $("#"+$v).removeClass('active').removeClass('show');
            $articlesList.find('.nav-pills .nav-link[data-target="#'+$v+'"]').removeClass('disabled');
        });
        $articlesList.find('.nav-pills .nav-link[data-target="#'+$tab+'"]').addClass('active');
        $("#"+$tab).addClass('active').addClass('show');
        if(cback != undefined){
            cback();
        }
    },
    article_list_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=6; $i++){
            $chtml += '' +
                '<div class="col-md-6 preview">' +
                '    <a href="javascript:void(0)">' +
                '        <div class="card article-card mb-4">' +
                '            <div class="article-card-image article-list-preload">' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            </div>' +
                '            <div class="d-flex p-3">' +
                '                <div class="profile-img mr-3 article-list-preload">' +
                '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100 article-list-preload">' +
                '                    <h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h4>' +
                '                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '                </div>' +
                '            </div>' +
                '            <div class="article-card-desc px-3 article-list-preload">' +
                '                <h3>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3>' +
                '                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '            </div>' +
                '            <div class="article-card-tags px-3 article-list-preload">' +
                '                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
                '            </div>' +
                '        </div>' +
                '    </a>' +
                '</div>';
        }
        return $chtml;
    },
    article_list_pagination:function($tab, $filter){
        nurseslounge_myDashboard_myArticles.tab_open = $tab;
        $filter = $filter == undefined ? '' : $filter;
        var $reload;
        var $loaded = false;
        var $tabDiv = $("#"+$tab);
        var $articleContent = $tabDiv.find('.article-content:first');
        var $paginationNav = $tabDiv.find('.pagination-nav:first');
        var $resultInfo = $tabDiv.find('.result-info-count:first');
        var $paginationObj;
        var $data = $.extend({}, {user_id:libs.memoryGet('user_id'), tab:$tab, filter:$filter});
        var $notificationTypeKey = libs.memoryGet('nurseslounge_myDashboard_myArticles_notificationTypeKey');
        try{
            $paginationObj = libs.memoryGet('article_list_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        if($tab == 'published-articles' && $notificationTypeKey){
            $data = $.extend({}, $data, {notification_type_key:$notificationTypeKey});
            var $articlesList = $("#nurseslounge-home-articles .articles-list");
            $articlesList.find('.nav-pills .nav-link[data-target="#'+$tab+'"]').removeClass('active');
            libs.memorySave('nurseslounge_myDashboard_myArticles_notificationTypeKey', false);
        }else{
            router.pause();
            router.navigate('/myDashboard/myArticles');
            router.resume();
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: 6,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/myDashboard/myArticles/lists",
            locator: 'data.articles',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$data,
                beforeSend: function() {
                    $articleContent.html(nurseslounge_myDashboard_myArticles.article_list_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('article-list-preload');
                $resultInfo.removeClass('article-list-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Articles</span>');
                var $chtml = '<div class="col-12 mt-1 mb-3"><h5 class="w-100 text-center soft pb-5 text-info"><div onclick="nurseslounge_myDashboard_myArticles.goto(\'editor\');" class="create-article cursor-pointer"><img src="/bimg/NursesLounge/create-articles.png" class="img-fluid"></div></h5></div>';
                var $items = nurseslounge_myDashboard_myArticles.item_html($data);
                $chtml += $items;
                if($items != ''){
                    libs.checkImageLoad($($chtml).find('img'), function () {
                        $articleContent.html('').html($chtml).promise().done(function () {
                            nurseslounge_myDashboard_myArticles.list_events();
                        });
                    });
                }else{
                    var $txt = '';
                    switch ($tab) {
                        case 'published-articles':
                            $txt = '<a href="javascript:void(0)" class="create-article cursor-pointer"><img src="/bimg/NursesLounge/create-articles.png" class="img-fluid"></a>' +
                                '<br><br>Pending and Approved articles you create will show up here.';
                            break;
                        case 'like-articles':
                            $txt = 'Articles you like will show up here.<br> Click the heart icon on any article to like it.';
                            break;
                        case 'recommended-articles':
                            $txt = 'Welcome to Articles!<br> As nurses generate content we\'ll recommend articles relevant to your career, here.';
                            break;
                        case 'recently-viewed-articles':
                            $txt = 'You have not seen any article yet.';
                            break;
                        case 'draft-articles':
                            $txt = 'Articles you save as drafts will show up here.';
                            break;
                        case 'trash-articles':
                            $txt = 'Empty trash.';
                            break;
                    }
                    $chtml = '' +
                        '<div class="col-12 mt-1">' +
                        '   <h5 class="w-100 text-center soft pb-5 text-info">' +
                        $txt +
                        '   </h5>' +
                        '</div>';
                    $articleContent.html($chtml).promise().done(function(){
                        var $createArticle = $articleContent.find('.create-article');
                        $createArticle.unbind().click(function(){
                            nurseslounge_myDashboard_myArticles.goto('editor');
                        });
                    });
                }
            }
        });
        libs.memorySave('article_list_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_myDashboard_myArticles.article_list_pagination($tab, $filter);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    item_html:function($data){
        var $chtml = '';
        $.each($data, function($i, $v){
            var $AF = $v.article_features;
            var $date = $AF.updated_at ? $AF.updated_at : null;
            var $headline = $AF.headline && $AF.headline != '' ? $AF.headline: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
            var $_author = $AF.author && $AF.author != '' ? $AF.author: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
            var $wildcard = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
            var $description;
            if($AF.html && $AF.html != '' && $AF.html != null){
                try{
                    $description = $($AF.html).text();
                }catch ($e) {
                    $description = $AF.html;
                }
            }else{
                $description = $wildcard;
            }
            if($description != $wildcard){
                $description = $description.length > 50 ? $description.substr(0, 50) + '...' : $description;
            }

            var $user = $v.user;
            var $author = $user.long_name;
            var $jobTitle = $user && $user.job_title ? $user.job_title : '&nbsp;&nbsp;&nbsp;&nbsp;';
            var $authorLink = $user.profile_url;
            var $profileImage = $user.profile_image_root_wall + '?resize=46';

            var $imgOption1 = $AF && $AF.image && $AF.image.document_thumb_root ? $AF.image.document_thumb_root : null;
            var $imgOption2 = $v.document_thumb_root;

            var $imageThumb = $imgOption1 != null ? $imgOption1 : $imgOption2;
            var $articleLikesCount = $v.article_likes_count == 1  ? $v.article_likes_count + ' like' : $v.article_likes_count + ' likes';
            var $iAmOwner = $v.i_am_owner;
            var $status = $AF.status;
            var $myLike = $v.my_like ? 'like' : '';
            var $viewedByMe = $v.viewed_by_me;
            var $documentId = $v.id;
            var $expirationDate = $AF && $AF.expiration_date && $AF.expiration_date ? $AF.expiration_date : null;
            var $categories = $v.article_categories ? $v.article_categories : [];
            var $categoriesTxt = [];
            var $articleTags = [];
            if($AF && $AF.specialty && $AF.specialty.type) {
                $articleTags.push({tag:$AF.specialty.type});
            }
            if($AF && $AF.degree && $AF.degree.subcategory){
                $articleTags.push({tag:$AF.degree.subcategory});
            }
            $articleTags = $.merge($articleTags, $v.article_tags);
            for (var $i in $categories){
                $categoriesTxt.push($categories[$i].category.category);
            }

            $chtml += '' +
                '<div class="col-md-6 item" ' +
                '   data-id="'+$documentId+'" ' +
                '   data-viewbyme="'+$viewedByMe+'" ' +
                '   data-status="'+$status+'" ' +
                '   data-iamowner="'+$iAmOwner+'" ' +
                '>' +
                '   <div class="card article-card mb-4">' +
                '     <div class="article-card-image">' +
                '         <img src="'+$imageThumb+'?resize=524x250" alt="article image" class="img-fluid">' +
                '     </div>'+
                '     <div class="d-flex p-3">' +
                '         <div class="profile-img mr-3">' +
                '            <a href="'+$authorLink+'" target="_blank">' +
                '                <img src="'+$profileImage+'" alt="profile">' +
                '            </a>' +
                '         </div>' +
                '         <div class="list-info align-self-center w-100">' +
                '            <a href="'+$authorLink+'" target="_blank">' +
                '                <h4>'+$author+'</h4>' +
                '                <h6>'+$jobTitle+'</h6>' +
                '            </a>';
            if($status == 'published') {
            $chtml += '' +
                '          <p>Published <span class="article-date" data-id="' + $documentId + '" data-articledate="' + $date + '"></span></p>';
            }
            if($status == 'draft') {
            $chtml += '' +
                '         <p class="row my-2">' +
                '             Not yet published' +
                '         </p>';
            }
            if($status == 'trash') {
                $chtml += '' +
                    '       <p>Deleted <span class="article-date" data-id="' + $documentId + '" data-articledate="' + $date + '"></span></p>';
            }
            $chtml += '' +
                '         </div>' +
                '     </div>' +
                '     <div class="article-card-desc px-3">' +
                '         <h3>'+$headline+'</h3>'+
                '         <p>' + $description + '</p>'+
                '         <small>' + $_author + '</small>';
            if($expirationDate){
                $expirationDate =  moment.utc($expirationDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
                $chtml += '' +
                    '         <div class="small">Expire: ' + $expirationDate + '</div>';
            }else{
                $chtml += '' +
                    '         <div class="small">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>';
            }
            if($categoriesTxt.length > 0){
                $chtml += '' +
                    '         <div class="small">' + $categoriesTxt.join(', ') + '</div>';
            }else{
                $chtml += '' +
                    '         <div class="small">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>';
            }
            if($status == 'published') {
            $chtml += '' +
                '         <button type="button" class="like-button ' + $myLike + ' m-3 float-right">' +
                '             <i class="fa fa-heart"></i>' +
                '         </button>';
            }
            if($status == 'draft' || $status == 'trash') {
            $chtml += '' +
                '         <button type="button" class="edit-button m-3 float-right">' +
                '             <i class="fa fa-pencil-square-o"></i>' +
                '         </button>';
            }
            $chtml += '' +
                '     </div>' +
                '     <div class="article-card-tags px-3">';
                $.each($articleTags, function($sI, $sV){
                    $chtml += '<div class="tag">' + $sV.tag + '</div>';
                });
            $chtml += '' +
                '     </div>';
            if($status == 'published') {
            $chtml += '' +
                '     <div class="total-likes float-right px-5">' +
                $articleLikesCount +
                '     </div>';
            }
            if($status == 'draft' || $status == 'trash') {
            $chtml += '' +
                '         <div class="row my-1">' +
                '             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '         </div>';
            }
            $chtml += '' +
                '   </div>' +
                '</div>';
        });
        return $chtml;
    },
    articles_dates:[],
    articles_dates_binding:null,
    server_date_helper:null,
    server_date:null,
    set_server_date:function($serverDate){
        this.server_date_helper = new Date();
        this.server_date = new Date($serverDate);
    },
    get_server_date:function(){
        var $now  = new Date().getTime();
        var $diff = $now - this.server_date_helper.getTime();
        var $date = this.server_date.getTime() + $diff;
        return new Date($date);
    },
    set_articles_dates:function($articlesIds){
        this.articles_dates = $articlesIds;
    },
    get_articles_dates:function(){
        return this.articles_dates;
    },
    articles_date:function(cback){
        var $artcilesDate = libs.memoryGet('articles_date');
        if($artcilesDate){
            try{
                $artcilesDate.abort();
            }catch($e){

            }
        }
        $artcilesDate = $.ajax({
            url:location.href,
            method: "GET",
            cache:false,
            dataType: "html",
            success: function ($data, $status, $response) {
                var $dateString = $response.getResponseHeader('date');
                if ($dateString.indexOf('GMT')) {
                    $dateString = $dateString.replace('GMT','');
                }
                nurseslounge_myDashboard_myArticles.set_server_date($dateString);
                nurseslounge_myDashboard_myArticles.articles_date_html();
                if(cback != undefined){
                    cback();
                }
            }
        });
        libs.memorySave('articles_date', $artcilesDate);
    },
    articles_date_html:function(){
        var $refreshEverySeconds = 1;
        var $now = nurseslounge_myDashboard_myArticles.get_server_date().getTime();
        var $articlesDates = nurseslounge_myDashboard_myArticles.get_articles_dates();
        for(var $i in $articlesDates){
            var $key = $articlesDates[$i];
            $(document).find('.article-date[data-id="'+$key+'"]').each(function () {
                var $ele = $(this);
                if($ele.length > 0){
                    var $val = $ele.data('articledate');
                    var $newDate = $val.split(' ');
                    var $yearMonthDay = $newDate[0];
                    $yearMonthDay = $yearMonthDay.split('-');
                    var $HourMinuteSecond = $newDate[1];
                    $HourMinuteSecond = $HourMinuteSecond.split(':');
                    var $date = new Date($yearMonthDay[0], $yearMonthDay[1] - 1, $yearMonthDay[2], $HourMinuteSecond[0], $HourMinuteSecond[1], $HourMinuteSecond[2]);
                    var $second = $date.getSeconds();
                    $second = $second <= 9 ? '0' + $second : $second;
                    var $minute = $date.getMinutes();
                    $minute = $minute <= 9 ? '0' + $minute : $minute;
                    var $hour = $date.getHours();
                    $hour = $hour <= 9 ? '0' + $hour : $hour;
                    var $day = $date.getDate();
                    $day = $day <= 9 ? '0' + $day : $day;
                    var $month = $date.getMonth() + 1;
                    $month = $month <= 9 ? '0' + $month : $month;
                    var $year = $date.getFullYear();
                    var $articleDate =  $year + '-' + $month + '-' + $day + ' ' + $hour + ':'+ $minute + ':' + $second;
                    $date = $date.getTime();
                    var $diffSeconds = Math.floor(($now - $date)/1000);
                    var $diffMinutes = Math.floor($diffSeconds/60);
                    var $diffHours = Math.floor($diffMinutes/60);
                    var $diffDays = Math.floor($diffHours/24);
                    var $chtml = '';
                    if($diffDays == 0 && $diffHours == 0 && $diffMinutes == 0){
                        $chtml = $diffSeconds == 1 ? $diffSeconds + ' second ago' : $diffSeconds + ' seconds ago';
                    }else
                    if ($diffDays == 0 && $diffHours == 0){
                        $chtml = $diffMinutes == 1 ? $diffMinutes + ' minute ago' : $diffMinutes + ' minutes ago';
                    }else
                    if ($diffDays == 0){
                        $chtml = $diffHours == 1 ? $diffHours + ' hour ago' : $diffHours + ' hours ago';
                    }else
                    if($diffDays < 4){
                        $chtml = $diffDays == 1 ? $diffDays + ' day ago' : $diffDays + ' days ago';
                    }else{
                        $date = $ele.data('articledate');
                        $chtml =  moment.utc($date, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
                    }
                    if($ele.html() != $chtml){
                        $ele.data('articledate', $articleDate).html($chtml);
                    }
                }
            });
        }
        try{
            clearTimeout(this.articles_dates_binding);
        }catch($e){}
        this.articles_dates_binding = setTimeout(function(){
            nurseslounge_myDashboard_myArticles.articles_date_html();
        }, ($refreshEverySeconds * 1000));
    },
    list_events:function(){
        var nlWallDocumentPreview = $(window).nurseslounge_myDashboard_wall_get({user_id:libs.memoryGet('user_id')}, 'nlWallDocumentPreview');
        var $articleList = $("#nurseslounge-home-articles .articles-list");
        var $articleContent = $articleList.find('.article-content');
        var $items = $articleContent.find('.item');
        $items.unbind().click(function($e){
            $e.stopPropagation();
            $e.preventDefault();
            var $that = $(this);
            var $documentId = $that.data('id');
            var $status = $that.data('status');
            var $params = {
                document_id:$documentId,
                user_id:libs.memoryGet('user_id'),
                status:$status
            };
            if($status == 'published'){
                nurseslounge_myDashboard_myArticles.events_recently_viewed_request($params, function() {
                    nlWallDocumentPreview.init($documentId);
                });
            }
            if($status == 'draft' || $status == 'trash') {
                nurseslounge_myDashboard_myArticles.events_draft_viewed_request($params, function($data){
                    var $id = libs.getUniqueId();
                    libs.memorySave('article'+$id, {
                        document_root:null,
                        document_preview_root:null,
                        document_thumb_root:null,
                        type:'article',
                        name:null,
                        date:moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                        user:{
                            long_name:$data.data.document.user.long_name,
                            profile_image_root_wall:$data.data.document.user.profile_image_root_wall
                        },
                        article_features:{
                            headline:$data.data.document.article_features.headline,
                            author:$data.data.document.article_features.author,
                            html:$data.data.document.article_features.html,
                            degree:$data.data.document.article_features.degree,
                            specialty:$data.data.document.article_features.specialty,
                            expiration_date:$data.data.document.article_features.expiration_date,
                            image:{
                                document_root:$data.data.document.article_features.image && $data.data.document.article_features.image.document_root ? $data.data.document.article_features.image.document_root : null
                            }
                        },
                        article_categories:$data.data.document.article_categories,
                        article_tags:$data.data.document.article_tags,
                        article_lounges:$data.data.document.article_lounges
                    });
                    nlWallDocumentPreview.popup('article',$id, {article:{disabled:['download']}});
                });
            }
        });
        var $a = $articleContent.find('a');
        $a.unbind().click(function($e){
            $e.stopPropagation();
            $e.preventDefault();
            var $that = $(this);
            var $href = $that.attr('href');
            window.open($href, '_blank');
        });
        var $likeButton = $articleContent.find('.like-button');
        $likeButton.unbind().click(function($e){
            $e.stopPropagation();
            $e.preventDefault();
            var $that = $(this);
            var $like = !$that.hasClass('like');
            var $item = $that.parents('.item:first');
            var $documentId = $item.data('id');
            var $totalLikes = $item.find('.total-likes:first');
            var $params = {
                document_id:$documentId,
                user_id:libs.memoryGet('user_id'),
                like:$like,
            };
            nurseslounge_myDashboard_myArticles.events_like_request($params, function($data){
                if($data.data.like){
                    $that.addClass('like');
                }else{
                    $that.removeClass('like');
                }
                var $likes = $data.data.likes == 1 ? $data.data.likes+' like' : $data.data.likes + ' likes';
                $totalLikes.html($likes);
                $articleList.find('.like-articles-count').html($data.data.likes_articles_count);
            });
        });
        var $editButton = $articleContent.find('.edit-button');
        $editButton.unbind().click(function($e){
            $e.stopPropagation();
            $e.preventDefault();
            var $that = $(this);
            var $item = $that.parents('.item:first');
            var $documentId = $item.data('id');
            libs.memorySave('editor', {
                user_id:libs.memoryGet('user_id'),
                document:{id:$documentId},
            });
            nurseslounge_myDashboard_myArticles.goto('editor');
        });
        //Search Events
        var $inputSearchLikeArticles= $articleList.find('input[name="searchLikeArticles"]:first');
        var $inputSearchDraftArticles = $articleList.find('input[name="searchDraftArticles"]:first');
        var $inputSearchPublishedArticles = $articleList.find('input[name="searchPublishedArticles"]:first');
        var $keyPressBinding;
        $inputSearchLikeArticles.unbind().on('keyup keydown keypress', function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $val = $that.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_myArticles.article_list_pagination($tab, $val);
            }, 800);
        });
        $inputSearchDraftArticles.unbind().on('keyup keydown keypress', function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $val = $that.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_myArticles.article_list_pagination($tab, $val);
            }, 800);
        });
        $inputSearchPublishedArticles.unbind().on('keyup keydown keypress', function(){
            var $that = $(this);
            var $tab = $that.data('tab');
            var $val = $that.val();
            try{
                clearTimeout($keyPressBinding);
            }catch($e){

            }
            $keyPressBinding = setTimeout(function(){
                nurseslounge_myDashboard_myArticles.article_list_pagination($tab, $val);
            }, 800);
        });
        //Realtime Clock
        var $articlesIds = [];
        $articleContent.find(".item").each(function(){
            var $that = $(this);
            $articlesIds.push($that.data('id'));
        });
        $articlesIds.sort();
        $articlesIds = $.unique($articlesIds);
        nurseslounge_myDashboard_myArticles.set_articles_dates($articlesIds);
        nurseslounge_myDashboard_myArticles.articles_date();
        //Refresh Tabs Counts
        nurseslounge_myDashboard_myArticles.refresh_articles_count();
    },
    events_recently_viewed_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/myArticles/viewed",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback();
                }
            }
        });
    },
    events_draft_viewed_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/myArticles/draftTrashView",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    events_like_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/myArticles/like",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    refresh_articles_count:function(){
        var $articleList = $("#nurseslounge-home-articles .articles-list");
        var $artcilesCount = libs.memoryGet('articles_count');
        if($artcilesCount){
            try{
                $artcilesCount.abort();
            }catch($e){

            }
        }
        $artcilesCount = $.ajax({
            url: "/myDashboard/myArticles/count",
            method: "POST",
            cache:false,
            dataType: "json",
            data:{user_id:libs.memoryGet('user_id')},
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    $articleList.find('.like-articles-count').html($data.data.likes_articles_count);
                    $articleList.find('.published-articles-count').html($data.data.published_articles_count);
                    $articleList.find('.draft-articles-count').html($data.data.draft_articles_count);
                    $articleList.find('.trash-articles-count').html($data.data.trash_articles_count);
                }
            }
        });
        libs.memorySave('articles_date', $artcilesCount);
    },
    //Editor
    editor:function(){
        var $homeArticles = $('#nurseslounge-home-articles');
        var $editorWrapper = $homeArticles.find('.editor-wrapper');
        var $editorPreload = $editorWrapper.find(".editor-preload");
        var $editorContainer = $editorWrapper.find('.editor-container');
        $editorContainer.hide();
        $editorPreload.show();
        nurseslounge_myDashboard_myArticles.editor_dropzone();
        var $textP = $editorContainer.find('.text-processor');
        var $uploadDocuments = function ($context) {
            var ui = $.summernote.ui;
            var button = ui.button({
                contents: '<i class="fa fa-upload"/> Upload Doc',
                tooltip: 'upload doc',
                click: function () {
                    var $chtml = '<input type="file" class="nurseslounge_myDashboard_myArticle_update" name="file" accept=".doc, .docx">';
                    $('.nurseslounge_myDashboard_myArticle_update').remove();
                    $('body').append($chtml).ready(function(){
                        $('.nurseslounge_myDashboard_myArticle_update').change(function(){
                            var $formData = new FormData();
                            $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                            $formData.append('user_id', libs.memoryGet('user_id'));
                            $formData.append('file', this.files[0]);
                            $.ajax({
                                type: 'POST',
                                url: '/myDashboard/myArticles/content',
                                data: $formData,
                                cache: false,
                                contentType: false,
                                processData: false,
                                success: function ($data) {
                                    libs.expire($data);
                                    $('.nurseslounge_myDashboard_myArticle_update').remove();
                                    var $txt = $data.data.txt;
                                    $txt = $txt.replace(/\n/g, "<br />");
                                    $context.invoke('editor.pasteHTML', $txt);
                                }
                            });
                        }).click();
                    });
                }
            });
            return button.render();
        }
        var $uploadPDF = function ($context) {
            var ui = $.summernote.ui;
            var button = ui.button({
                contents: '<i class="fa fa-upload"/> Upload PDF',
                tooltip: 'upload doc',
                click: function () {
                    var $chtml = '<input type="file" class="nurseslounge_myDashboard_myArticle_update" name="file" accept=".pdf">';
                    $('.nurseslounge_myDashboard_myArticle_update').remove();
                    $('body').append($chtml).ready(function(){
                        $('.nurseslounge_myDashboard_myArticle_update').change(function(){
                            var $formData = new FormData();
                            $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                            $formData.append('user_id', libs.memoryGet('user_id'));
                            $formData.append('file', this.files[0]);
                            $.ajax({
                                type: 'POST',
                                url: '/myDashboard/myArticles/content',
                                data: $formData,
                                cache: false,
                                contentType: false,
                                processData: false,
                                success: function ($data) {
                                    libs.expire($data);
                                    $('.nurseslounge_myDashboard_myArticle_update').remove();
                                    var $txt = $data.data.txt;
                                    $txt = $txt.replace(/\n/g, "<br />");
                                    $context.invoke('editor.pasteHTML', $txt);
                                }
                            });
                        }).click();
                    });
                }
            });
            return button.render();
        }
        var $deleteFormat = function ($context) {
            var ui = $.summernote.ui;
            var button = ui.button({
                contents: '<i class="fa fa-wpforms"/> Delete Format',
                tooltip: 'format',
                click: function () {
                    var $textP = $editorContainer.find('.text-processor');
                    var $text = $textP.summernote('code');
                    var $regex = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
                    var $plainText = $text.replace($regex, '');
                    $textP.summernote('code', $plainText);
                }
            });
            return button.render();
        }
        try{
            $textP.summernote('destroy');
        }catch (e) {

        }
        var $keypressBinding;
        var $bindingMatch;
        $textP.summernote({
            disableDragAndDrop:false,
            placeholder: 'Write your text here...',
            height: '350px',
            width: '100%',
            focus: true,
            disableResizeEditor: true,
            dialogsInBody: true,
            dialogsFade: true,
            codeviewFilter: true,
            codeviewIframeFilter: true,
            spellCheck: true,
            disableGrammar: false,
            hint: {
                match: /\B@(\w*)$/,
                search: function ($keyword, cback) {
                    try{
                        clearTimeout($bindingMatch);
                    }catch (e) {

                    }
                    $bindingMatch = setTimeout(function(){
                        nurseslounge_myDashboard_myArticles.editor_match($keyword, function($data){
                            if($data.data.friends.length > 0){
                                cback($data.data.friends);
                            }
                        });
                    }, 800);
                },
                template:function($item){
                    return $item.long_name;
                },
                content: function ($item) {
                    return $('<a href="'+$item.profile_url+'">@' + $item.long_name+'</a>')[0];
                }
            },
            styleTags: [
                'p',
                'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
            ],
            fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New'],
            popover: {
                image: [
                    ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter']],
                    ['remove', ['removeMedia']]
                ]
            },
            toolbar: [
                ['document', ['uploadDocuments', 'uploadPDF', 'deleteFormat']],
                ['font', ['fontname']],
                ['font', ['bold', 'italic', 'underline']],
                ['para', ['ul', 'ol', 'paragraph']],
            ],
            buttons: {
                uploadDocuments: $uploadDocuments,
                uploadPDF: $uploadPDF,
                deleteFormat: $deleteFormat,
            },
            callbacks: {
                onChange: function($chtml, $editable) {
                    try {
                        clearTimeout($keypressBinding);
                    } catch (e) {

                    }
                    $keypressBinding = setTimeout(function () {
                        var $editor = libs.memoryGet('editor');
                        var $articleFeatures = $.extend({}, $editor.document.article_features, {preview_html:$chtml != '' ? $chtml : null});
                        nurseslounge_myDashboard_myArticles.editor_add({
                            document:{
                                article_features:$articleFeatures
                            }
                        });
                    }, 800);
                }
            }
        });
        var $editorMemory = libs.memoryGet('editor');
        var $data = {};
        if(!$editorMemory){
            $data = {
                user_id:libs.memoryGet('user_id'),
                document:{},
            };
        }else{
            $data = $editorMemory;
        }
        $editorMemory = $.extend({}, $data, {
            editor_wrapper:$editorWrapper,
            text_processor:$textP
        });
        libs.memorySave('editor', $editorMemory);
        nurseslounge_myDashboard_myArticles.editor_events(function () {
            nurseslounge_myDashboard_myArticles.editor_verify_publication(function() {
                $editorPreload.hide();
                $editorContainer.css('display', 'inline-flex');
            });
        });
    },
    editor_dropzone:function(){
        var $homeArticles = $('#nurseslounge-home-articles');
        var $editorWrapper = $homeArticles.find('.editor-wrapper');
        var $editorContainer = $editorWrapper.find('.editor-container');
        var $editorDropImage = $editorContainer.find('.editor-drop-image');
        var $openAlbum = $editorDropImage.find('.open-album');
        Dropzone.autoDiscover = false;
        var $dropzone = libs.memoryGet('nurseslounge_myDashboard_myArticles_dropzone');
        try{
            $dropzone.destroy();
        }catch ($e) {

        }
        $dropzone = new Dropzone($editorDropImage[0], {
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            createImageThumbnails:false,
            acceptedFiles:'image/png,image/jpg,image/jpeg,image/gif',
            url: '/myDashboard/myArticles/fake',
            params:{user_id:libs.memoryGet('user_id')},
            method: 'post',
            clickable:[$editorDropImage[0], $editorDropImage.find('img:first')[0]],
            init: function() {
                var $that = this;
                $that.on("complete", function(){
                    $editorDropImage.find('.dz-preview').remove();
                });
                $that.on("success", function($file) {
                    var $formData = new FormData();
                    $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                    $formData.append('user_id', libs.memoryGet('user_id'));
                    $formData.append('file', $file);
                    $formData.append('file_type', 'image');
                    var nlWallUpdate = $(window).nurseslounge_myDashboard_wall_get({user_id:libs.memoryGet('user_id')}, 'nlWallUpdate');
                    nlWallUpdate.analyze($formData, function($data){
                        if($data.status == 'error'){
                            return false;
                        }
                        $formData.append('thumb_file', libs.b64toBlob($data.data.features.thumb));
                        $formData.append('original_name', $data.data.features.original_name);
                        if(
                            $data.data.features.mime_type == 'image/png' ||
                            $data.data.features.mime_type == 'image/jpg' ||
                            $data.data.features.mime_type == 'image/jpeg' ||
                            $data.data.features.mime_type == 'image/gif'
                        ) {
                            $formData.append('preview_file', libs.b64toBlob($data.data.features.preview));
                            $formData.append('file_type', 'image');
                            $formData.append('action', 'save');
                            nlWallUpdate.save($formData, function($data){
                                var $chtml = '' +
                                    '<img '+
                                    '   src="'+$data.data.updated_file.document_root+'" ' +
                                    '   class="attach-image img-fluid" ' +
                                    '>';
                                if($data.status == 'success'){
                                    $editorDropImage.find(".attach-image").replaceWith($chtml).promise().done(function(){
                                        nurseslounge_myDashboard_myArticles.editor_dropzone();
                                    });
                                }
                            });
                        }
                    });
                });
            }
        });
        libs.memorySave('nurseslounge_myDashboard_myArticles_dropzone', $dropzone);
        $openAlbum.unbind().click(function(){
            var nlWallAlbum = $(window).nurseslounge_myDashboard_wall_get({user_id:libs.memoryGet('user_id')}, 'nlWallAlbum');
            var nlWallUpdate = $(window).nurseslounge_myDashboard_wall_get({user_id:libs.memoryGet('user_id')}, 'nlWallUpdate');
            nlWallAlbum.open({
                on_close_modal:false,
                on_end_callback:false,
                on_start_callback:false,
                album_allow_tabs : {
                    'profile_webcam_image':true,
                    'profile_image':true,
                    'profile_document':false,
                    'profile_video':false,
                    'profile_article':false
                },
                album_step:11,
                album_allow_add:true,
                album_allow_select:true
            }, function($data){
                var $document = $data.data.updated_file;
                nlWallUpdate.fill($document, {
                    get_data_callback:function($file){
                        var $chtml = '' +
                            '<img '+
                            '   src="'+$file.document_root+'" ' +
                            '   class="attach-image img-fluid" ' +
                            '>';
                        $editorDropImage.find(".attach-image").replaceWith($chtml).promise().done(function(){
                            nurseslounge_myDashboard_myArticles.editor_dropzone();
                        });
                    }
                });
            });
        });
    },
    editor_events:function(cback){
        var $editorMemory = libs.memoryGet('editor');
        var $editorWrapper = $editorMemory.editor_wrapper;
        var $editorMenu = $editorWrapper.find('.editor-menu');
        var $clickAction;
        var $degree =$editorWrapper.find('select[name="degree"]');
        var $specialty =$editorWrapper.find('select[name="specialty"]');
        var $tags = $editorWrapper.find('input[name="tags"]');
        var $lounges = $editorWrapper.find('input[name="lounges"]');
        var $expirationDate = $editorWrapper.find('input[name="expirationDate"]');
        var $category = $editorWrapper.find('select[name="category"]');
        var $resetExpirationDate = $editorWrapper.find('.reset_expiration_date');
        $degree.val('');
        $specialty.val('');
        $(".tagify__input").each(function(){
           var $that = $(this);
           if($that.html() == ''){
               $that.remove();
           }
        });
        var $tagifyLounges = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_lounges');
        if($tagifyLounges){
            try{
                $tagifyLounges.DOM.input.classList.remove('tagify__input--outside');
                $tagifyLounges.removeAllTags();
                $tagifyLounges.destroy();
            }catch ($e) {

            }
        }
        $tagifyLounges = new Tagify($lounges[0], {
            enforceWhitelist:true,
            skipInvalid: true,
            whitelist: [],
            dropdown : {
                position      : "text"
            }
        });
        $tagifyLounges.DOM.input.classList.add('tagify__input--outside');
        $tagifyLounges.DOM.scope.parentNode.insertBefore($tagifyLounges.DOM.input, $tagifyLounges.DOM.scope);
        $tagifyLounges.loading(true).dropdown.hide.call($tagifyLounges);
        $tagifyLounges.on('input', function($e){
            $tagifyLounges.settings.whitelist.length = null;
            $.ajax({
                url: "/myDashboard/myArticles/lounges",
                method: "POST",
                cache:false,
                dataType: "json",
                data:{user_id:libs.memoryGet('user_id'),value:$e.detail.value},
                success: function ($data) {
                    libs.expire($data);
                    $tagifyLounges.settings.whitelist = $data;
                    $tagifyLounges.loading(false).dropdown.show.call($tagifyLounges, $e.detail.value);
                }
            });
        });
        libs.memorySave('nurseslounge_myDashboard_myArticles_tagify_lounges', $tagifyLounges);

        var $tagifyTags = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_tags');
        if($tagifyTags){
            try{
                $tagifyTags.DOM.input.classList.remove('tagify__input--outside');
                $tagifyTags.removeAllTags();
                $tagifyTags.destroy();
            }catch ($e) {

            }
        }
        $tagifyTags = new Tagify($tags[0]);
        $tagifyTags.DOM.input.classList.add('tagify__input--outside');
        $tagifyTags.DOM.scope.parentNode.insertBefore($tagifyTags.DOM.input, $tagifyTags.DOM.scope);
        libs.memorySave('nurseslounge_myDashboard_myArticles_tagify_tags', $tagifyTags);

        $expirationDate.val('').datepicker();
        $category.val('');
        $category.chosen();
        $resetExpirationDate.unbind().click(function(){
            $expirationDate.val('').datepicker("update");
        });
        nurseslounge_myDashboard_myArticles.editor_validator(function($form){
            var $action = $clickAction;
            switch($action){
                case 'preview':
                    nurseslounge_myDashboard_myArticles.editor_preview_option();
                    break;
                case 'draft':
                    nurseslounge_myDashboard_myArticles.editor_set_article($action, function(){
                        nurseslounge_myDashboard_myArticles.goto('articles', 'draft-articles', true, function(){
                            nurseslounge_myDashboard_myArticles.editor_new_option_event();
                        });
                    });
                    break;
                case 'published':
                    nurseslounge_myDashboard_myArticles.editor_set_article($action, function () {
                        nurseslounge_myDashboard_myArticles.goto('articles', 'published-articles', true,function(){
                            nurseslounge_myDashboard_myArticles.publish_popup();
                            nurseslounge_myDashboard_myArticles.editor_new_option_event();
                        });
                    });
                    break;
                case 'trash':
                    nurseslounge_myDashboard_myArticles.editor_set_article($action, function(){
                        nurseslounge_myDashboard_myArticles.goto('articles', 'trash-articles', true, function(){
                            nurseslounge_myDashboard_myArticles.editor_new_option_event();
                        });
                    });
                    break;
            }
        });
        $editorMenu.find('.action').unbind().click(function(){
            $editorMemory = libs.memoryGet('editor');
            var $action = $(this).data('action');
            switch ($action) {
                case 'new':
                    nurseslounge_myDashboard_myArticles.editor_new_option();
                    break;
                case 'preview':
                    $clickAction = $action;
                    $(this).submit();
                    break;
                case 'draft':
                    $clickAction = $action;
                    $(this).submit();
                    break;
                case 'published':
                    $clickAction = $action;
                    $(this).submit();
                    break;
                case 'trash':
                    $clickAction = $action;
                    $(this).submit();
                    break;
            }
        });
        if(cback != undefined){
            cback();
        }
    },
    publish_popup:function(){
        $("#nurseslounge-myDashboard-myArticles-modal").modal('show');
    },
    editor_verify_publication:function(cback){
        var $editorMemory = libs.memoryGet('editor');
        var $editorWrapper = $editorMemory.editor_wrapper;
        var $editorMenu = $editorWrapper.find('.editor-menu');
        $editorMenu.find('.action').hide();
        if($editorMemory && $editorMemory.document && $editorMemory.document.id) {
            var $userId = $editorMemory.user_id;
            var $attachImage = $editorWrapper.find('.editor-drop-image .attach-image:first');
            var $headline =$editorWrapper.find('input[name="headline"]');
            var $author =$editorWrapper.find('input[name="author"]');
            var $degree =$editorWrapper.find('select[name="degree"]');
            var $specialty =$editorWrapper.find('select[name="specialty"]');
            var $expirationDate =$editorWrapper.find('input[name="expirationDate"]');
            var $categories =$editorWrapper.find('select[name="category"]');
            var $categoriesVal = [];

            var $textP = $editorMemory.text_processor;
            var $tagifyLounges = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_lounges');
            var $tagify = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_tags');
            $.ajax({
                url: "/myDashboard/myArticles/verifyPublication",
                method: "POST",
                cache: false,
                dataType: "json",
                data: {user_id: libs.memoryGet('user_id'), document_id: $editorMemory.document.id},
                success: function ($data) {
                    libs.expire($data);
                    if ($data.status == 'success') {
                        var $document = $data.data.document;
                        $headline.val('');
                        if($document.article_features && $document.article_features.headline){
                            $headline.val($document.article_features.headline);
                        }else{
                            $headline.val('');
                        }
                        $author.val('');
                        if($document.article_features && $document.article_features.author){
                            $author.val($document.article_features.author);
                        }else{
                            $author.val('');
                        }
                        $attachImage.attr('src', window.location.origin + '/bimg/NursesLounge/dragAndDrop.png');
                        if($document.article_features && $document.article_features.image && $document.article_features.image.document_root){
                            $attachImage.attr('src', $document.article_features.image.document_root);
                        }else{
                            $attachImage.attr('src', window.location.origin + '/bimg/NursesLounge/dragAndDrop.png');
                        }
                        $textP.summernote('code', '');
                        if($document.article_features && $document.article_features && $document.article_features.html){
                            $textP.summernote('code', $document.article_features.html);
                        }else{
                            $textP.summernote('code', '');
                        }
                        $tagifyLounges.removeAllTags();
                        if($document && $document.article_lounges){
                            var $lounges = [];
                            $.each($document.article_lounges, function($i, $v){
                                $lounges.push($v.lounge);
                            });
                            $tagifyLounges.settings.whitelist = $lounges;
                            $tagifyLounges.addTags($lounges);
                        }
                        $tagify.removeAllTags();
                        if($document && $document.article_tags){
                            var $tags = [];
                            $.each($document.article_tags, function($i, $v){
                                $tags.push($v.tag);
                            });
                            $tagify.addTags($tags);
                        }
                        $degree.val('');
                        if(
                            $document &&
                            $document.article_features &&
                            $document.article_features.degree &&
                            $document.article_features.degree.id
                        ){
                            $degree.val($document.article_features.degree.id);
                        }
                        $specialty.val('');
                        if(
                            $document &&
                            $document.article_features &&
                            $document.article_features.specialty &&
                            $document.article_features.specialty.id
                        ){
                            $specialty.val($document.article_features.specialty.id);
                        }
                        $categories.val('');
                        if(
                            $document &&
                            $document.article_categories)
                        {
                            for (var $i in $document.article_categories){
                                $categoriesVal.push($document.article_categories[$i].category_id);
                            }
                            $categories.val($categoriesVal);
                            $categories.trigger("chosen:updated");
                        }
                        $expirationDate.val('');
                        if(
                            $document &&
                            $document.article_features &&
                            $document.article_features.expiration_date
                        ){
                            var $date = moment.utc($document.article_features.expiration_date, 'YYYY-MM-DD').format('MM/DD/YYYY')
                            $expirationDate.val($date);
                        }
                        if(
                            $document &&
                            $document.article_features &&
                            $document.article_features.status
                        ){
                            if($document.article_features.status == 'draft'){
                                $editorMenu.find('button[data-action="trash"]').show();
                                $editorMenu.find('button[data-action="draft"]').show();
                                $editorMenu.find('button[data-action="preview"]').show();
                                $editorMenu.find('button[data-action="published"]').show();
                                $editorMenu.find('button[data-action="new"]').hide();
                            }
                            if($document.article_features.status == 'trash'){
                                $editorMenu.find('button[data-action="trash"]').hide();
                                $editorMenu.find('button[data-action="draft"]').show();
                                $editorMenu.find('button[data-action="preview"]').show();
                                $editorMenu.find('button[data-action="published"]').show();
                                $editorMenu.find('button[data-action="new"]').hide();
                            }
                        }
                        libs.memoryUpdateObj('editor', {
                            document:$document,
                        });
                        cback();
                    }
                }
            });
        }else{
            $editorMenu.find('button[data-action="trash"]').show();
            $editorMenu.find('button[data-action="draft"]').show();
            $editorMenu.find('button[data-action="preview"]').show();
            $editorMenu.find('button[data-action="published"]').show();
            $editorMenu.find('button[data-action="new"]').show();
            cback();
        }
    },
    editor_match:function($keyword, cback){
        $.ajax({
            url: "/myDashboard/myArticles/match",
            method: "POST",
            cache:false,
            dataType: "json",
            data:{user_id:libs.memoryGet('user_id'), keyword:$keyword},
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    cback($data);
                }
            }
        });
    },
    editor_validator:function(cback){
        $.validator.addMethod("mintext", function($val, $ele, $params) {
            return $params != '';
        }, "* The tags cannot be more than 5");
        $.validator.addMethod("maxtags", function($val, $ele, $params) {
            return $params <= 5;
        }, "* The tags cannot be more than 5");
        var $validator;
        try {
            $validator = $("#nurseslounge-home-articles form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-articles form").validate({
            onsubmit: true,
            debug: true,
            ignore: "*:not(.validate)",
            rules: {
                headline: {
                    required: true,
                },
                author: {
                    required: true,
                },
                html: {
                    mintext: function(){
                        var $editorMemory = libs.memoryGet('editor');
                        var $textP = $editorMemory.text_processor;
                        var $val =  $textP.summernote('code');
                        try{
                            $val = $($val).text();
                        }catch ($e) {

                        }
                        return $val;
                    },
                },
                specialty: {
                    required: false
                },
                degree: {
                    required: false
                },
                lounges:{
                    required:false,
                },
                tags: {
                    maxtags: function(){
                        var $tags = [];
                        var $val = $("#nurseslounge-home-articles form input[name='tags']").val();
                        if($val != '') {
                            var $selectedTags = JSON.parse($val);
                            for (var $i in $selectedTags) {
                                $tags.push($selectedTags[$i].value);
                            }
                        }
                        return $tags.length;
                    },
                },
            },
            messages: {
                headline: {
                    required: "The headline is required"
                },
                author: {
                    required: "The author is required"
                },
                html: {
                    mintext: "The article must have at least 1 characters",
                },
                specialty: {
                    required: "The specialty is not required"
                },
                degree: {
                    required: "The degree is not required"
                },
                lounges:{
                    required: "The lounges are not required",
                },
                tags: {
                    maxtags: "The tags cannot be more than 5",
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    editor_add:function($obj){
        var $editorMemory = libs.memoryGet('editor');
        $editorMemory = libs.extendReplace($editorMemory, $obj);
        libs.memorySave('editor', $editorMemory);
    },
    editor_save_diff:function(){
        var $editorMemory = libs.memoryGet('editor');
        var $editorWrapper = $editorMemory.editor_wrapper;
        var $imageVal = $editorWrapper ? $editorWrapper.find('.editor-drop-image .attach-image:first').attr('src') : window.location.origin + '/bimg/NursesLounge/dragAndDrop.png';
        var $imageSaved = $editorMemory.document && $editorMemory.document.article_features && $editorMemory.document.article_features.image && $editorMemory.document.article_features.image.document_root ? $editorMemory.document.article_features.image.document_root : window.location.origin + '/bimg/NursesLounge/dragAndDrop.png';
        var $headlineVal = $editorWrapper ? $editorWrapper.find('input[name="headline"]').val() : '';
        var $headlineSaved = $editorMemory.document && $editorMemory.document.article_features && $editorMemory.document.article_features.headline ? $editorMemory.document.article_features.headline : '';
        var $htmlVal = $editorWrapper ? $editorMemory.text_processor.summernote('code') : '<p><br></p>';
        var $htmlSaved = $editorMemory.document && $editorMemory.document.article_features && $editorMemory.document.article_features.html ? $editorMemory.document.article_features.html : '<p><br></p>';
        var $specialtyVal = $editorWrapper ? $editorWrapper.find('select[name="specialty"]').val() : '';
        var $specialtySaved = $editorMemory.document && $editorMemory.document.article_features && $editorMemory.document.article_features.specialty && $editorMemory.document.article_features.specialty.id ? $editorMemory.document.article_features.specialty.id : '';
        var $degreeVal = $editorWrapper ? $editorWrapper.find('select[name="degree"]').val() : '';
        var $degreeSaved = $editorMemory.document && $editorMemory.document.article_features && $editorMemory.document.article_features.degree && $editorMemory.document.article_features.degree.id ? $editorMemory.document.article_features.degree.id : '';
        var $expirationDateVal = $editorWrapper ? $editorWrapper.find('input[name="expirationDate"]').val() : '';
        var $expirationDateSaved = $editorMemory.document && $editorMemory.document.article_features && $editorMemory.document.article_features.expiration_date ? $editorMemory.document.article_features.expiration_date : '';
        if($expirationDateVal != ''){
            $expirationDateVal = moment.utc($expirationDateVal, 'MM/DD/YYYY').format('YYYY-MM-DD')
        }
        var $categoriesValArr = $editorWrapper ? $editorWrapper.find('select[name="category"]').val() : [];
        var $categoriesArr = $editorMemory.document && $editorMemory.document.article_categories ? $editorMemory.document.article_categories : [];
        var $categoriesVal = [];
        var $categoriesSaved = [];
        $.each($categoriesValArr, function($i, $v){
            $categoriesVal.push(parseInt($v));
        });
        $.each($categoriesArr, function($i, $v){
            $categoriesSaved.push($v.category_id);
        });
        $categoriesVal = $categoriesVal.sort().join(',');
        $categoriesSaved = $categoriesSaved.sort().join(',');

        var $tagsLounge = [];
        var $tagifyLounge = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_lounges');
        $.each($tagifyLounge.value, function($i, $v){
            $tagsLounge.push($v.value);
        });
        $tagsLounge = $tagsLounge.sort();
        var $tagsLoungeVal = $tagsLounge.join(',');

        var $tagsLoungeSaved = [];
        var $documentLoungeTags = $editorMemory.document && $editorMemory.document.article_lounges && $editorMemory.document.article_lounges ? $editorMemory.document.article_lounges : [];
        $.each($documentLoungeTags, function($i, $v){
            $tagsLoungeSaved.push($v.lounge);
        });
        $tagsLoungeSaved = $tagsLoungeSaved.sort();
        $tagsLoungeSaved = $tagsLoungeSaved.join(',');

        var $tags = [];
        var $tagify = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_tags');
        $.each($tagify.value, function($i, $v){
            $tags.push($v.value);
        });
        $tags = $tags.sort();
        var $tagsVal = $tags.join(',');

        var $tagsSaved = [];
        var $documentTags = $editorMemory.document && $editorMemory.document.article_tags && $editorMemory.document.article_tags ? $editorMemory.document.article_tags : [];
        $.each($documentTags, function($i, $v){
            $tagsSaved.push($v.tag);
        });
        $tagsSaved = $tagsSaved.sort();
        $tagsSaved = $tagsSaved.join(',');

        return (
            $imageVal != $imageSaved ||
            $headlineVal != $headlineSaved ||
            $htmlVal != $htmlSaved ||
            $specialtyVal != $specialtySaved ||
            $degreeVal != $degreeSaved ||
            $tagsVal != $tagsSaved ||
            $tagsLoungeVal != $tagsLoungeSaved ||
            $expirationDateVal != $expirationDateSaved ||
            $categoriesVal != $categoriesSaved
        )
    },
    editor_is_not_saved_msg:function(cback){
        var $modal = $("#home-my-profile-my-editor-modal");
        var $modalBody = $modal.find('.modal-body:first');
        var $chtml = '' +
            '<div class="float-left mx-2">' +
            '   <i class="icon fa fa-exclamation-triangle bg-exclamation"></i>' +
            '</div>' +
            '<small>This article is not saved<br>If you continue you can lost the changes</small>' +
            '<div class="form-group mt-3">' +
            '   <button type="button" class="mx-1 btn btn-save btnAnimate float-right continue">Continue</button>' +
            '   <button type="button" class="mx-1 btn btn-light float-right cancel">Cancel</button>' +
            '</div>';
            $modalBody.html($chtml).promise().done(function(){
                $modalBody.find('.cancel').unbind().click(function(){
                    $modal.modal('hide');
                });
                $modalBody.find('.continue').unbind().click(function(){
                    cback($modal);
                });
            });
        $modal.modal('show');
    },
    editor_is_not_saved:function($section, $tab, cback){
        if(
            $tab == undefined && $section == 'articles' && nurseslounge_myDashboard_myArticles.editor_save_diff()
        ) {
            nurseslounge_myDashboard_myArticles.editor_is_not_saved_msg(function($modal){
                nurseslounge_myDashboard_myArticles.editor_new_option_event();
                cback();
                $modal.modal('hide');
            });
        }else{
            nurseslounge_myDashboard_myArticles.editor_new_option_event();
            cback();
        }
    },
    editor_new_option:function(){
        if(
            nurseslounge_myDashboard_myArticles.editor_save_diff()
        ) {
            nurseslounge_myDashboard_myArticles.editor_is_not_saved_msg(function($modal){
                nurseslounge_myDashboard_myArticles.editor_new_option_event();
                $modal.modal('hide');
            });
        }else{
            nurseslounge_myDashboard_myArticles.editor_new_option_event();
        }
    },
    editor_new_option_event:function(){
        var $editorMemory = libs.memoryGet('editor');
        if($editorMemory && $editorMemory.document && $editorMemory.document.id) {
            var $editorWrapper = $editorMemory.editor_wrapper;
            var $textP = $editorMemory.text_processor;
            if($editorWrapper != undefined && $textP != undefined){
                var $data = {
                    user_id: $editorMemory.user_id,
                    document: {},
                    editor_wrapper: $editorWrapper,
                    text_processor: $textP,
                };
                libs.memorySave('editor', $data);
                var $attachImage = $editorWrapper.find('.editor-drop-image .attach-image:first');
                var $headline = $editorWrapper.find('input[name="headline"]');
                var $specialty = $editorWrapper.find('select[name="specialty"]');
                var $degree = $editorWrapper.find('select[name="degree"]');
                var $expirationDate = $editorWrapper.find('input[name="expirationDate"]');
                var $category = $editorWrapper.find('select[name="category"]');
                var $tagifyLounges = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_lounges');
                var $tagify = libs.memoryGet('nurseslounge_myDashboard_myArticles_tagify_tags');
                $attachImage.attr('src', window.location.origin + '/bimg/NursesLounge/dragAndDrop.png');
                $headline.val('');
                $textP.summernote('code', '');
                $specialty.val('');
                $degree.val('');
                $tagifyLounges.removeAllTags();
                $tagify.removeAllTags();
                $expirationDate.val('').datepicker();
                $category.val('');
                $category.trigger("chosen:updated");
            }
        }
    },
    editor_preview_option:function(){
        var $editorMemory = libs.memoryGet('editor');
        var $textP = $editorMemory.text_processor;
        var $chtml = $textP.summernote('code');
        var $editorWrapper = $editorMemory.editor_wrapper;
        var $attachImage = $editorWrapper.find('.editor-drop-image .attach-image:first');
        var $image = $attachImage.attr('src');
        $image = $image != window.location.origin + '/bimg/NursesLounge/dragAndDrop.png' ? $image : null;
        var $headline = $editorWrapper.find('input[name="headline"]');
        var $author = $editorWrapper.find('input[name="author"]');
        var $specialtySelect = $editorWrapper.find('select[name="specialty"] option:selected');
        var $degreeSelect = $editorWrapper.find('select[name="degree"] option:selected');
        var $expirationDate = $editorWrapper.find('input[name="expirationDate"]');
        var $categorySelect = $editorWrapper.find('select[name="category"]');

        var $tags = [];
        var $tagsVal = $editorWrapper.find("input[name='tags']").val();
        if($tagsVal != '') {
            var $selectedTags = JSON.parse($tagsVal);
            for (var $i in $selectedTags) {
                $tags.push({tag:$selectedTags[$i].value});
            }
        }
        var $lounges = [];
        var $loungesVal = $editorWrapper.find("input[name='lounges']").val();
        if($loungesVal != '') {
            var $selectedLounges = JSON.parse($loungesVal);
            for (var $i in $selectedLounges) {
                $lounges.push($selectedLounges[$i].value);
            }
        }
        var $specialty = {};
        var $specialtyId = $specialtySelect.val();
        if($specialtyId != ''){
            $specialty['id'] =  $specialtyId;
            $specialty['type'] = $specialtySelect.text();
        }
        var $degree = {};
        var $degreeId = $degreeSelect.val();
        if($degreeId != ''){
            $degree['id'] = $degreeId;
            $degree['subcategory'] = $degreeSelect.text();
        }
        var $categories = [];
        var $categoriesIds = $categorySelect.val();
        if($categoriesIds.length > 0){
            $categorySelect.find('option:selected').map(function() {
                var $category = [];
                var $id = $(this).attr('value');
                $category['id'] = $id;
                var $text = $categorySelect.find('option[value='+$id+']').text();
                var $helper = {};
                $helper.category = $text;
                $category['category'] = $helper;
                $categories.push($category);
            })
        }
        var $expirationDateFormat = moment.utc($expirationDate.val(), 'MM/DD/YYYY').format('YYYY/MM/DD');
        var nlWallDocumentPreview = $(window).nurseslounge_myDashboard_wall_get({user_id:libs.memoryGet('user_id')}, 'nlWallDocumentPreview');
        var $id = libs.getUniqueId();
        nurseslounge_myDashboard_myArticles.editor_who_i_am(function($data){
            libs.memorySave('article'+$id, {
                document_root:null,
                document_preview_root:null,
                document_thumb_root:null,
                type:'article',
                name:null,
                date:moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                user:{
                    long_name:$data.data.user.long_name,
                    profile_image_root_wall:$data.data.user.profile_image_root_wall
                },
                article_features:{
                    headline:$headline.val(),
                    author:$author.val(),
                    html:$chtml,
                    specialty:$specialty,
                    degree:$degree,
                    expiration_date:$expirationDateFormat,
                    image:{
                        document_root:$image
                    },
                },
                article_categories:$categories,
                article_tags:$tags,
                article_lounges:$lounges
            });
            nlWallDocumentPreview.popup('article',$id, {article:{disabled:['download']}});
        });
    },
    editor_who_i_am:function(cback){
        $.ajax({
            url: "/myDashboard/myArticles/whoIAm",
            method: "POST",
            cache: false,
            dataType: "json",
            data: {user_id: libs.memoryGet('user_id')},
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    cback($data);
                }
            }
        });
    },
    editor_set_article:function($action, cback){
        var $editorMemory = libs.memoryGet('editor');
        var $textP = $editorMemory.text_processor;
        var $chtml = $textP.summernote('code');
        var $editorWrapper = $editorMemory.editor_wrapper;
        var $attachImage = $editorWrapper.find('.editor-drop-image .attach-image:first');
        var $image = $attachImage.attr('src');
        $image = $image != window.location.origin + '/bimg/NursesLounge/dragAndDrop.png' ? $image : null;
        var $headline =$editorWrapper.find('input[name="headline"]');
        var $author =$editorWrapper.find('input[name="author"]');
        var $specialtySelect =$editorWrapper.find('select[name="specialty"] option:selected');
        var $degreeSelect =$editorWrapper.find('select[name="degree"] option:selected');
        var $expirationDate = $editorWrapper.find('input[name="expirationDate"]');
        var $categorySelect = $editorWrapper.find('select[name="category"]');

        var $specialty = {};
        var $specialtyId = $specialtySelect.val();
        if($specialtyId != ''){
            $specialty['id'] =  $specialtyId;
            $specialty['type'] = $specialtySelect.text();
        }
        var $degree = {};
        var $degreeId = $degreeSelect.val();
        if($degreeId != ''){
            $degree['id'] = $degreeId;
            $degree['subcategory'] = $degreeSelect.text();
        }
        var $lounges = [];
        var $loungesVal = $editorWrapper.find("input[name='lounges']").val();
        if($loungesVal != '') {
            var $selectedLounges = JSON.parse($loungesVal);
            for (var $i in $selectedLounges) {
                $lounges.push($selectedLounges[$i].value);
            }
        }
        var $tags = [];
        var $tagsVal = $editorWrapper.find("input[name='tags']").val();
        if($tagsVal != '') {
            var $selectedTags = JSON.parse($tagsVal);
            for (var $i in $selectedTags) {
                $tags.push($selectedTags[$i].value);
            }
        }
        var $expirationDateFormat = null;
        if($expirationDate.val() != ''){
            $expirationDateFormat = moment.utc($expirationDate.val(), 'MM/DD/YYYY').format('YYYY-MM-DD');
        }
        nurseslounge_myDashboard_myArticles.editor_add(
            {
                action:$action,
                editor_wrapper:null,
                text_processor:null,
                document:{
                    article_features:{
                        headline:$headline.val(),
                        author:$author.val(),
                        html:$chtml,
                        preview_html:$chtml,
                        specialty:$specialty,
                        degree:$degree,
                        expiration_date:$expirationDateFormat,
                        image:{
                            document_root:$image
                        }
                    },
                    article_categories:$categorySelect.val(),
                    article_tags:$tags,
                    article_lounges:$lounges
                }
            });
        $.ajax({
            url: "/myDashboard/myArticles/set",
            method: "POST",
            cache:false,
            dataType: "json",
            data:libs.memoryGet('editor'),
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    libs.memorySave('editor', $data.data.request);
                    nurseslounge_myDashboard_myArticles.editor_add(
                        {
                            action:null,
                            editor_wrapper:$editorWrapper,
                            text_processor:$textP
                        });
                    nurseslounge_myDashboard_myArticles.editor_verify_publication(function(){
                        if(cback != undefined){
                            cback();
                        }
                    });
                }
            }
        });
    },
};
